import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 -1 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor"
  }, [
    _createElementVNode("g", { "stroke-width": "0" }),
    _createElementVNode("g", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    _createElementVNode("g", null, [
      _createElementVNode("g", {
        stroke: "none",
        "stroke-width": "1",
        fill: "currentColor",
        "fill-rule": "evenodd"
      }, [
        _createElementVNode("g", {
          transform: "translate(-206.000000, -206.000000)",
          fill: "currentColor"
        }, [
          _createElementVNode("path", { d: "M224,222 C224,221.634 223.895,221.296 223.723,221 L220.277,221 C220.105,221.296 220,221.634 220,222 C220,223.104 220.896,224 222,224 C223.104,224 224,223.104 224,222 L224,222 Z M226,222 C226,224.209 224.209,226 222,226 C219.791,226 218,224.209 218,222 C218,221.652 218.054,221.319 218.141,221 L206,221 L206,232 C206,234.209 207.791,236 210,236 L234,236 C236.209,236 238,234.209 238,232 L238,221 L225.859,221 C225.946,221.319 226,221.652 226,222 L226,222 Z M226,210 L218,210 L218,209 C218,208.448 218.448,208 219,208 L225,208 C225.552,208 226,208.448 226,209 L226,210 L226,210 Z M234,210 L228,210 L228,208 C228,206.896 227.104,206 226,206 L218,206 C216.896,206 216,206.896 216,208 L216,210 L210,210 C207.791,210 206,211.791 206,214 L206,219 L238,219 L238,214 C238,211.791 236.209,210 234,210 L234,210 Z" })
        ])
      ])
    ])
  ]))
}